'use strict';
module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-html/index.js
// module id = 981
// module chunks = 0